module.exports = __webpack_public_path__ + "img/CM-SS-CA-Hyundai-Modern.ed370bea.jpg";